import { ArrowRight } from "lucide-react";

export const BackBar = ({ onBack }) => (
  <button type="button" onClick={onBack} data-testid="page-back-btn"
    className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-600 shadow-sm transition-colors hover:bg-slate-50">
    <ArrowRight className="h-4 w-4" /> رجوع
  </button>
);
